import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=66d9857f"
import script from "./Assessment.vue?vue&type=script&lang=js"
export * from "./Assessment.vue?vue&type=script&lang=js"
import style0 from "./Assessment.vue?vue&type=style&index=0&id=66d9857f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports